import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const BIGFOOTERBODYSOCIALNETWORKSBLOCK_LEGACY_FIELD_ORDER = [
  "heading",
  "alignment",
  "icon_color",
  "facebook_link",
  "twitter_link",
  "linkedin_link",
  "instagram_link",
  "tiktok_link",
  "google_link",
  "icon_size"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  bigFooterBodySocialNetworksBlockDescriptor: _generatedBigFooterBodySocialNetworksBlockDescriptor,
  bigFooterBodySocialNetworksBlockBlocDefinition,
  bigFooterBodySocialNetworksBlockDashboardLayout,
  bigFooterBodySocialNetworksBlockConfig,
  bigFooterBodySocialNetworksBlockResolveConfig,
  bigFooterBodySocialNetworksBlockProperties,
} = doodBlockConfig(
  {
    name: "Réseaux sociaux",
    componentType: 'BigFooterBodySocialNetworksBlockComponent',
    category: 'footer',
    description: "Liens vers les réseaux sociaux (Facebook, X, LinkedIn, Instagram, TikTok, Google).",
    keywords: [
      "social",
      "networks",
      "social networks",
      "liens",
      "liens réseaux sociaux",
      "réseaux",
      "reseaux",
      "réseaux sociaux",
      "reseaux sociaux",
      "facebook",
      "instagram",
      "linkedin",
      "twitter",
      "x",
      "tiktok",
      "google",
      "big footer",
    ],
    allowedIn: [
      { bloc: "BigFooterBlockComponent", slot: "left_body" },
      { bloc: "BigFooterColumnBlockComponent", slot: "items" },
      { bloc: "ContainerBlockComponent", slot: "container_blocks" },
      { bloc: "LegalsFooterBlockComponent", slot: "extras" },
    ],
    sharedFields: {}
  },

  () => ({
    heading: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-footer-body-social-networks.heading.label",
      }
    }),
    alignment: propertyValue({
      type: 'select',
      value: "left",
      options: {
        label: "pages.blocks.big-footer-body-social-networks.alignment.label",
        choices: [
          {
            value: "left",
            label: "pages.blocks.big-footer-body-social-networks.alignment.options.left",
          },
          {
            value: "center",
            label: "pages.blocks.big-footer-body-social-networks.alignment.options.center",
          },
        ],
      }
    }),
    icon_size: propertyValue({
      type: 'unit_value',
      value: { unit: 'px', value: 14 },
      options: {
        label: "pages.blocks.big-footer-body-social-networks.icon-size.label",
        help: "pages.blocks.big-footer-body-social-networks.icon-size.help",
        min: 0,
        step: 0.1,
        choices: [
          { value: 'px', label: 'px' },
          { value: 'rem', label: 'rem' },
          { value: 'vw', label: 'vw' },
          { value: 'vh', label: 'vh' },
        ],
      }
    }),
    icon_color: propertyValue({
      type: 'color',
      value: { type: 'palette', value: 'primary-600' },
      options: {
        label: "pages.blocks.big-footer-body-social-networks.icon-color.label",
        help: "pages.blocks.big-footer-body-social-networks.icon-color.help",
      }
    }),
    facebook_link: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-footer-body-social-networks.facebook-link.label",
      }
    }),
    twitter_link: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-footer-body-social-networks.twitter-link.label",
      }
    }),
    linkedin_link: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-footer-body-social-networks.linkedin-link.label",
      }
    }),
    instagram_link: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-footer-body-social-networks.instagram-link.label",
      }
    }),
    tiktok_link: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-footer-body-social-networks.tiktok-link.label",
      }
    }),
    google_link: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-footer-body-social-networks.google-link.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.big-footer-body-social-networks.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.big-footer-body-social-networks.fieldset.title.label",
            fields: ["heading", "alignment", "icon_size", "icon_color"],
          },
          {
            legend: "pages.blocks.big-footer-body-social-networks.fieldset.networks.label",
            fields: [
              "facebook_link",
              "twitter_link",
              "linkedin_link",
              "instagram_link",
              "tiktok_link",
              "google_link",
            ],
          },
        ],
      },
    ],
  })
);

export function bigFooterBodySocialNetworksBlockDescriptor(): IBlockDescriptor;
export function bigFooterBodySocialNetworksBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function bigFooterBodySocialNetworksBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedBigFooterBodySocialNetworksBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedBigFooterBodySocialNetworksBlockDescriptor, bigFooterBodySocialNetworksBlockProperties, fieldOrder);
}

export {
  bigFooterBodySocialNetworksBlockBlocDefinition,
  bigFooterBodySocialNetworksBlockDashboardLayout,
  bigFooterBodySocialNetworksBlockProperties,
  bigFooterBodySocialNetworksBlockConfig,
  bigFooterBodySocialNetworksBlockResolveConfig,
};

export type BigFooterBodySocialNetworksBlockConfig = typeof bigFooterBodySocialNetworksBlockConfig;
